import { ChevronRight } from '@bnnvara/icons/src/components/UserInterfaceIcons/ChevronRight';
import React from 'react';
import * as S from './styled';

export const HeroNextArrow = (
  <S.SlideArrow
    role="button"
    aria-label="Ga naar het volgende item"
    title="Ga naar het volgende item"
  >
    <ChevronRight />
  </S.SlideArrow>
);
